import { Injectable, signal, computed } from '@angular/core';

/**
 * Servicio global para el overlay de carga.
 * Mantiene un contador de peticiones HTTP activas; el overlay se muestra cuando hay al menos una.
 * Usado por LoadingInterceptor para mostrar/ocultar automáticamente en cada request.
 */
@Injectable({ providedIn: 'root' })
export class LoadingOverlayService {
  private readonly pendingCount = signal(0);

  /** true cuando hay al menos una petición en curso */
  readonly isLoading = computed(() => this.pendingCount() > 0);

  /** Aumenta el contador (llamado al iniciar cada request) */
  show(): void {
    this.pendingCount.update((n) => n + 1);
  }

  /** Disminuye el contador (llamado al finalizar cada request, éxito o error) */
  hide(): void {
    this.pendingCount.update((n) => Math.max(0, n - 1));
  }
}
